import Flickity from 'flickity';

export default class {
	constructor(node) {
		this.node = node;
		this.wrap = node.querySelector('.mr__items');
		this.items = Array.from( node.querySelectorAll('.mr__item') );

		this.flickity = new Flickity(this.wrap, {
			cellAlign: 'left',
			// wrapAround: true,
			// adaptiveHeight: true,
			// watchCSS: true,
			// initialIndex: 1,
			arrowShape: 'M28,57.67,56.66,87.18a7.68,7.68,0,0,1,0,10.62,7.13,7.13,0,0,1-10.3,0L0,50,46.36,2.22a7.13,7.13,0,0,1,10.3,0,7.68,7.68,0,0,1,0,10.62l0,0L27.75,42.65l65-.15a7.51,7.51,0,0,1,0,15Z',
			on: {
				ready: () => {
					// adjust dot nav
					this.nav = document.createElement('div');
					this.nav.className = 'mr__nav';
					this.wrap.appendChild(this.nav);

					this.pageDots   = this.wrap.querySelector('.flickity-page-dots');
					this.prevButton = this.wrap.querySelector('.flickity-button.previous');
					this.nextButton = this.wrap.querySelector('.flickity-button.next');

					[ this.prevButton, this.pageDots, this.nextButton ].forEach((n) => {
						if (n) {
							this.nav.appendChild(n);
						}
					});

					this.resize();
				}
			}
		});

		window.addEventListener('resize', this.resize.bind(this));
	}

	resize() {
		this.items.forEach( item => item.style.height = '' );

		const sizes = this.items.map(item => item.offsetHeight);
		const max = Math.max.apply(null, sizes);

		this.items.forEach( item => item.style.height = `${max}px` );
	}
}
